import CTABannerContainer from 'components/home/cta-sticky-banner/cta-banner-container';
import CustomContent from 'components/landing/custom-content/custom-content';
import CustomHead from 'core/custom-head';
import Footer from 'components/footer/footer';
import getConstants from 'utils/query-data-parser/landing/get-constant';
import Header from 'components/home/header';
import { PageInfoContextProvider } from 'context/PageInfoContext';
import PropTypes from 'prop-types';
import ScriptContainer from 'components/container/script-container';
import Scroller from 'components/home/scroller';
import SelectedNoteList from 'components/landing/selected-note-list/selected-note-list';
import withHydrationOnDemand from 'react-hydration-on-demand';

const CustomContentH = withHydrationOnDemand({ on: ['visible'] })(CustomContent);
const FooterH = withHydrationOnDemand({ on: ['visible'] })(Footer);

const BlogSearch = ({ culture, payload }) => {
    return (
        <>
            <CustomHead pageInfo={payload} />
            <ScriptContainer
                breadcrumbList={payload.page_context.page_breadcrumb_list}
            >
                <PageInfoContextProvider data={payload}>
                    <Scroller />
                    <Header navbarType="blog-search" />
                    <SelectedNoteList
                        pageCode={payload.page_context.code}
                        title={payload.page_context.title}
                        domainProtocol={payload.page_context.domain_protocol}
                    />
                    <CustomContentH content={payload.page_context.content} />
                    <CTABannerContainer isBlog hideMobile />
                    <FooterH
                        showBestPrice={!payload.page_context.enable_banner}
                    />
                </PageInfoContextProvider>
            </ScriptContainer>
        </>
    );
};

export async function getServerSideProps ({ req }) {
    const data = req.apiData.data;
    const culture = data.page_context.page_lang;

    const payload = {
        ...data,
        ...getConstants(data.page_context)
    };

    return {
        props: {
            messages: (await import(`../messages/blog-search/${culture}.json`))
                .default,
            timeZone: req.apiData.timeZone,
            locale: culture.split('-')[1],
            culture,
            payload
        }
    };
}

BlogSearch.propTypes = {
    culture: PropTypes.string,
    payload: PropTypes.object
};

export default BlogSearch;
